import React from "react";
import { useNavigate } from "@Libs/Router/hooks/useNavigate";
import { useDisclosure } from "@UI/hooks/useDisclosure";
import { HStack, VStack } from "@UI/Components/Stack/Stack";
import { Icon } from "@UI/Components/Icon/Icon";
import { Text } from "@UI/Components/Text/Text";
import { FormattedMessage } from "@I18n/Components/FormattedMessage/FormattedMessage";
import { Warning } from "@UI/Components/Icons/Warning";
import { Button } from "@UI/Components/Button/Button";
import messages from "./messages";
import { EmailConfirmationInstructionModal } from "./EmailConfirmationInstructionModal";

export interface IConfirmationEmailTopProps {
  email: string;
  emailConfirmed: boolean;
  emailSentAt: string;
  emailBounced: boolean;
  isServiceProvider: boolean;
}
export const ConfirmationEmailTop = (props: IConfirmationEmailTopProps) => {
  if (props?.emailConfirmed) return null;
  const { isOpen, onOpen, onClose } = useDisclosure();

  const navigate = useNavigate();

  const modifyEmail = () => {
    navigate(
      !props?.isServiceProvider
        ? "CHANGE_EMAIL"
        : "CHANGE_EMAIL_FROM_DASHBOARD",
      {
        reload: true,
      }
    );
  };

  return (
    <HStack
      w="full"
      spacing="8px"
      py="12px"
      px="16px"
      background="orange.100"
      borderRadius="10px"
    >
      <Icon
        cursor="pointer"
        as={Warning}
        width="16px"
        height="16px"
        color="orange.700"
      />

      <VStack spacing="0" alignItems="start">
        <Text fontSize="md" fontWeight="700" color="gray.800">
          <FormattedMessage {...messages["confirmationEmailTop.title"]} />
        </Text>
        <Text fontSize="md" color="gray.800">
          <FormattedMessage
            {...messages[
              `confirmationEmailTop.${
                props?.emailBounced ? "incorrectEmail" : "subTitle"
              }`
            ]}
            values={{ email: props?.email }}
          />
        </Text>
        <Button
          variant="unstyled"
          h="fit-content"
          _hover={{ background: "none" }}
          onClick={props?.emailBounced ? modifyEmail : onOpen}
        >
          <Text
            fontSize="md"
            color="gray.800"
            textDecor="underline"
            _hover={{ textDecor: "none" }}
          >
            <FormattedMessage
              {...messages[
                `confirmationEmailTop.${
                  props?.emailBounced
                    ? "modifyEmailCTAText"
                    : "activateEmailCTAText"
                }`
              ]}
            />
          </Text>
        </Button>
      </VStack>
      <EmailConfirmationInstructionModal
        isOpen={isOpen}
        onClose={onClose}
        modifyEmail={modifyEmail}
        {...props}
      />
    </HStack>
  );
};
